import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  Utensils, 
  Smartphone, 
  BarChart3, 
  CreditCard, 
  Package, 
  Calendar,
  Check,
  Phone,
  Rocket,
  Play,
  CheckCircle,
  Shield,
  TrendingUp,
  Clock,
  Calculator,
  Mail,
  MapPin,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Menu,
  X,
  Star,
  ArrowRight,
  Zap,
  Users,
  DollarSign,
  Target,
  Award,
  Globe,
  ChevronDown,
  MousePointer,
  Sparkles,
  Heart,
  Lightbulb,
  Building,
  UserCheck,
  HeadphonesIcon
} from 'lucide-react';

const LandingPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [isVisible, setIsVisible] = useState({});
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const testimonials = [
    {
      name: "Maria Silva",
      role: "Diretora - Colégio Horizonte",
      content: "O CantinaTech revolucionou nossa cantina! As filas diminuíram 80% e os pais adoraram o controle total dos gastos.",
      avatar: "👩‍🏫",
      stats: "↗️ 85% menos filas",
      rating: 5
    },
    {
      name: "João Santos", 
      role: "Administrador - Escola Vitória",
      content: "Relatórios em tempo real nos ajudam a tomar decisões inteligentes. Vendas aumentaram 60% no primeiro mês!",
      avatar: "👨‍💼",
      stats: "📈 +60% vendas",
      rating: 5
    },
    {
      name: "Ana Costa",
      role: "Responsável Financeiro - Colégio São Paulo",
      content: "Finalmente temos controle total sobre nossa cantina. Sistema muito intuitivo e suporte excepcional!",
      avatar: "👩‍💻",
      stats: "💯 100% controle",
      rating: 5
    }
  ];

  const benefits = [
    {
      icon: TrendingUp,
      title: "Aumento de 60% nas Vendas",
      description: "PDV otimizado e app mobile aumentam significativamente o faturamento",
      color: "from-green-500 to-emerald-500",
      stat: "+60%"
    },
    {
      icon: Clock,
      title: "85% Menos Tempo de Fila",
      description: "Sistema rápido e pagamentos digitais eliminam filas demoradas",
      color: "from-blue-500 to-cyan-500",
      stat: "-85%"
    },
    {
      icon: Shield,
      title: "100% Controle dos Gastos",
      description: "Pais monitoram em tempo real o que os filhos consomem",
      color: "from-purple-500 to-pink-500",
      stat: "100%"
    },
    {
      icon: Heart,
      title: "98% Satisfação dos Pais",
      description: "App móvel e transparência total geram confiança",
      color: "from-red-500 to-orange-500",
      stat: "98%"
    }
  ];

  const features = [
    {
      icon: Utensils,
      title: "PDV Inteligente",
      description: "Sistema de vendas ultra-rápido com suporte a PIX, cartão e saldo digital",
      gradient: "from-blue-600 to-purple-600"
    },
    {
      icon: Smartphone,
      title: "App para Pais",
      description: "Controle total dos gastos, recargas instantâneas e notificações em tempo real",
      gradient: "from-purple-600 to-pink-600"
    },
    {
      icon: BarChart3,
      title: "Analytics Avançado",
      description: "Dashboards inteligentes com insights para maximizar seus resultados",
      gradient: "from-green-600 to-blue-600"
    },
    {
      icon: Package,
      title: "Gestão de Estoque",
      description: "Controle automatizado com alertas inteligentes de baixo estoque",
      gradient: "from-orange-600 to-red-600"
    },
    {
      icon: CreditCard,
      title: "PIX Integrado",
      description: "Recargas automáticas e pagamentos instantâneos via PIX",
      gradient: "from-teal-600 to-cyan-600"
    },
    {
      icon: Calendar,
      title: "Cardápio Digital",
      description: "Organize cardápios semanais e facilite o atendimento",
      gradient: "from-indigo-600 to-purple-600"
    }
  ];

  const plans = [
    {
      name: "Básico",
      subtitle: "Ideal para escolas pequenas",
      price: "197",
      originalPrice: "297",
      period: "/mês",
      discount: "34% OFF",
      popular: false,
      features: [
        "Até 100 alunos",
        "PDV completo",
        "App para pais",
        "Relatórios essenciais",
        "Suporte por email",
        "PIX integrado"
      ],
      ctaText: "Começar Grátis",
      badge: null
    },
    {
      name: "Profissional",
      subtitle: "Mais escolhido pelas escolas",
      price: "397",
      originalPrice: "597",
      period: "/mês",
      discount: "33% OFF",
      popular: true,
      features: [
        "Até 500 alunos",
        "Tudo do plano Básico",
        "Analytics avançado",
        "App + Portal web",
        "Integração banco",
        "Suporte prioritário",
        "Treinamento incluso"
      ],
      ctaText: "Teste 30 Dias Grátis",
      badge: "MAIS POPULAR"
    },
    {
      name: "Enterprise",
      subtitle: "Para grandes instituições",
      price: "697",
      originalPrice: "997",
      period: "/mês",
      discount: "30% OFF",
      popular: false,
      features: [
        "Alunos ilimitados",
        "Tudo do plano Pro",
        "API personalizada",
        "Múltiplas unidades",
        "Suporte 24/7",
        "Success Manager",
        "Implementação dedicada"
      ],
      ctaText: "Falar com Especialista",
      badge: "ENTERPRISE"
    }
  ];

  const stats = [
    { number: "1000+", label: "Escolas Atendidas", icon: Building },
    { number: "50k+", label: "Alunos Ativos", icon: Users },
    { number: "R$ 2M+", label: "Transacionado/Mês", icon: DollarSign },
    { number: "99.9%", label: "Uptime", icon: Shield }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(prev => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('[id]').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden">
      {/* Cursor personalizado */}
      {/* Removi a bolinha do cursor personalizado */}

      {/* Header futurístico */}
      <header className="fixed top-0 w-full z-40 bg-black/80 backdrop-blur-xl border-b border-gray-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <div className="relative">
                <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl flex items-center justify-center">
                  <Utensils className="w-6 h-6 text-white" />
                </div>
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-green-500 rounded-full animate-pulse" />
              </div>
              <span className="text-xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                CantinaTech
              </span>
            </div>

            {/* Navigation */}
            <nav className="hidden md:flex items-center space-x-8">
              {['Recursos', 'Preços', 'Cases', 'Contato'].map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase()}`}
                  className="text-gray-300 hover:text-white transition-colors duration-200 relative group"
                >
                  {item}
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-500 to-purple-500 transition-all duration-300 group-hover:w-full" />
                </a>
              ))}
            </nav>

            {/* CTA Button */}
            <div className="hidden md:flex items-center space-x-4">
              <Link
                to="/parents-login"
                className="text-gray-300 hover:text-white transition-colors"
              >
                Portal dos Pais
              </Link>
              <Link
                to="/login"
                className="text-gray-300 hover:text-white transition-colors"
              >
                Entrar
              </Link>
              <Link
                to="/register"
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 rounded-full hover:shadow-lg hover:shadow-blue-500/25 transition-all duration-300 transform hover:scale-105"
              >
                Teste Grátis
              </Link>
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-lg bg-gray-800 hover:bg-gray-700 transition-colors"
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-xl border-t border-gray-800">
            <div className="px-4 py-6 space-y-4">
              {['Recursos', 'Preços', 'Cases', 'Contato'].map((item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase()}`}
                  className="block text-gray-300 hover:text-white transition-colors py-2"
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item}
                </a>
              ))}
              <div className="pt-4 space-y-3">
                <Link
                  to="/parents-login"
                  className="block w-full text-center py-2 text-gray-300 hover:text-white transition-colors"
                >
                  Portal dos Pais
                </Link>
                <Link
                  to="/login"
                  className="block w-full text-center py-2 text-gray-300 hover:text-white transition-colors"
                >
                  Entrar
                </Link>
                <Link
                  to="/register"
                  className="block w-full text-center bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 rounded-full"
                >
                  Teste Grátis
                </Link>
              </div>
            </div>
          </div>
        )}
      </header>

      {/* Hero Section revolucionário */}
      <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background effects */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/20 via-purple-900/20 to-black" />
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl animate-pulse" />
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }} />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Badge de novidade */}
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-blue-500/10 to-purple-500/10 border border-blue-500/20 mb-8 animate-pulse">
            <Sparkles className="w-4 h-4 mr-2 text-blue-400" />
            <span className="text-sm text-blue-300">🎉 Agora com IA integrada para previsão de vendas</span>
          </div>

          {/* Headline principal */}
          <h1 className="text-5xl md:text-7xl font-bold mb-8 leading-tight">
            <span className="bg-gradient-to-r from-white via-blue-200 to-purple-200 bg-clip-text text-transparent">
              Transforme sua
            </span>
            <br />
            <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent animate-pulse">
              Cantina Escolar
            </span>
            <br />
            <span className="text-white">
              em uma
            </span>
            <span className="bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent ml-4">
              Máquina de Vendas
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-4xl mx-auto leading-relaxed">
            O único sistema que <strong className="text-white">aumenta suas vendas em 60%</strong>, 
            reduz filas em <strong className="text-white">85%</strong> e dá controle total aos pais. 
            <br />
            <span className="text-blue-400">Implementação em 24h + 30 dias grátis.</span>
          </p>

          {/* Social proof rápida */}
          <div className="flex items-center justify-center mb-12 space-x-8 text-sm text-gray-400">
            <div className="flex items-center">
              <div className="flex -space-x-2 mr-3">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full border-2 border-black flex items-center justify-center text-xs">
                    👥
                  </div>
                ))}
              </div>
              <span>1000+ escolas confiam</span>
            </div>
            <div className="flex items-center">
              <Star className="w-4 h-4 text-yellow-400 mr-1" />
              <span>4.9/5 (247 avaliações)</span>
            </div>
          </div>

          {/* CTAs principais */}
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mb-16">
            <Link
              to="/register"
              className="group relative bg-gradient-to-r from-blue-600 to-purple-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:shadow-2xl hover:shadow-blue-500/25 transition-all duration-300 transform hover:scale-105 flex items-center space-x-2"
            >
              <Rocket className="w-5 h-5" />
              <span>Começar Teste Grátis</span>
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full blur opacity-0 group-hover:opacity-50 transition-opacity duration-300 -z-10" />
            </Link>
            
            <button className="group flex items-center space-x-2 text-gray-300 hover:text-white transition-colors">
              <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm group-hover:bg-white/20 transition-colors">
                <Play className="w-5 h-5 ml-1" />
              </div>
              <span className="text-lg">Ver Demonstração (2 min)</span>
            </button>
          </div>

          {/* Garantias */}
          <div className="flex flex-wrap items-center justify-center space-x-8 text-sm text-gray-400">
            <div className="flex items-center mb-2">
              <CheckCircle className="w-4 h-4 text-green-400 mr-2" />
              <span>✅ Sem taxa de setup</span>
            </div>
            <div className="flex items-center mb-2">
              <CheckCircle className="w-4 h-4 text-green-400 mr-2" />
              <span>🎯 Implementação em 24h</span>
            </div>
            <div className="flex items-center mb-2">
              <CheckCircle className="w-4 h-4 text-green-400 mr-2" />
              <span>🛡️ Garantia de resultado</span>
            </div>
            <div className="flex items-center mb-2">
              <CheckCircle className="w-4 h-4 text-green-400 mr-2" />
              <span>📞 Suporte 24/7</span>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <ChevronDown className="w-6 h-6 text-gray-400" />
        </div>
      </section>

      {/* Stats Section impressionante */}
      <section id="stats" className="py-20 relative">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/5 to-purple-900/5" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div
                  key={index}
                  className={`text-center transform transition-all duration-700 ${
                    isVisible['stats'] ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                  }`}
                  style={{ transitionDelay: `${index * 200}ms` }}
                >
                  <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-6 border border-gray-700 hover:border-blue-500/50 transition-all duration-300 group">
                    <Icon className="w-8 h-8 text-blue-400 mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" />
                    <div className="text-3xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent mb-2">
                      {stat.number}
                    </div>
                    <div className="text-gray-400 text-sm">{stat.label}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Benefits Section com impacto visual */}
      <section id="benefits" className="py-20 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                Resultados que você vai
              </span>
              <br />
              <span className="bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">
                alcançar em 30 dias
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Mais de 1000 escolas já transformaram suas cantinas. 
              <strong className="text-white"> Agora é a sua vez.</strong>
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div
                  key={index}
                  className={`group relative bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border border-gray-700 hover:border-blue-500/50 transition-all duration-500 transform ${
                    isVisible['benefits'] ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                  }`}
                  style={{ transitionDelay: `${index * 200}ms` }}
                >
                  <div className={`inline-flex p-4 rounded-2xl bg-gradient-to-r ${benefit.color} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  
                  <div className="flex items-center justify-between mb-4">
                    <h3 className="text-2xl font-bold text-white group-hover:text-blue-400 transition-colors">
                      {benefit.title}
                    </h3>
                    <div className="text-3xl font-bold bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">
                      {benefit.stat}
                    </div>
                  </div>
                  
                  <p className="text-gray-400 text-lg leading-relaxed group-hover:text-gray-300 transition-colors">
                    {benefit.description}
                  </p>

                  <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Features Section moderna */}
      <section id="recursos" className="py-20 relative">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/5 to-purple-900/5" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                Tudo que você precisa
              </span>
              <br />
              <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                em uma única plataforma
              </span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div
                  key={index}
                  className={`group bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border border-gray-700 hover:border-blue-500/50 transition-all duration-500 transform hover:scale-105 ${
                    isVisible['recursos'] ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
                  }`}
                  style={{ transitionDelay: `${index * 100}ms` }}
                >
                  <div className={`inline-flex p-4 rounded-2xl bg-gradient-to-r ${feature.gradient} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  
                  <h3 className="text-xl font-bold text-white mb-4 group-hover:text-blue-400 transition-colors">
                    {feature.title}
                  </h3>
                  
                  <p className="text-gray-400 leading-relaxed group-hover:text-gray-300 transition-colors">
                    {feature.description}
                  </p>

                  <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Pricing Section irresistível */}
      <section id="preços" className="py-20 relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                Invista no crescimento
              </span>
              <br />
              <span className="bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">
                da sua cantina
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              <strong className="text-white">ROI médio de 300%</strong> no primeiro ano. 
              Sem taxa de setup. <strong className="text-green-400">30 dias grátis.</strong>
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {plans.map((plan, index) => (
              <div
                key={index}
                className={`relative bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border transition-all duration-500 transform hover:scale-105 ${
                  plan.popular 
                    ? 'border-blue-500 shadow-2xl shadow-blue-500/25 scale-105' 
                    : 'border-gray-700 hover:border-blue-500/50'
                } ${isVisible['preços'] ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}
                style={{ transitionDelay: `${index * 200}ms` }}
              >
                {plan.badge && (
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                    <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-1 rounded-full text-sm font-semibold">
                      {plan.badge}
                    </div>
                  </div>
                )}

                {plan.discount && (
                  <div className="absolute -top-3 -right-3">
                    <div className="bg-gradient-to-r from-green-500 to-emerald-500 text-white px-3 py-1 rounded-full text-xs font-bold animate-pulse">
                      {plan.discount}
                    </div>
                  </div>
                )}

                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold text-white mb-2">{plan.name}</h3>
                  <p className="text-gray-400 text-sm mb-6">{plan.subtitle}</p>
                  
                  <div className="mb-6">
                    {plan.originalPrice && (
                      <div className="text-gray-500 line-through text-lg mb-1">
                        R$ {plan.originalPrice}{plan.period}
                      </div>
                    )}
                    <div className="flex items-center justify-center">
                      <span className="text-5xl font-bold bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">
                        R$ {plan.price}
                      </span>
                      <span className="text-gray-400 ml-2">{plan.period}</span>
                    </div>
                  </div>
                </div>
                
                <ul className="space-y-4 mb-8">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-300">
                      <CheckCircle className="w-5 h-5 text-green-400 mr-3 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <Link
                  to="/register"
                  className={`block w-full text-center py-4 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105 ${
                    plan.popular
                      ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:shadow-lg hover:shadow-blue-500/25'
                      : 'bg-gray-700 text-white hover:bg-gray-600'
                  }`}
                >
                  {plan.ctaText}
                </Link>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-12">
            <p className="text-gray-400 mb-6">
              ✅ <strong className="text-white">Sem compromisso.</strong> Cancele quando quiser.
              <br />
              💳 Aceitamos PIX, cartão e transferência bancária.
            </p>
            <button className="inline-flex items-center text-blue-400 hover:text-blue-300 transition-colors">
              <Calculator className="w-5 h-5 mr-2" />
              Calcular meu ROI personalizado
            </button>
          </div>
        </div>
      </section>

      {/* Testimonials Section dinâmica */}
      <section id="cases" className="py-20 relative">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/5 to-purple-900/5" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                Histórias de
              </span>
              <br />
              <span className="bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent">
                Sucesso Reais
              </span>
            </h2>
          </div>

          <div className="relative max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-8 border border-gray-700">
              <div className="flex items-center mb-6">
                <div className="text-6xl mr-4">{testimonials[currentTestimonial].avatar}</div>
                <div>
                  <h4 className="text-xl font-semibold text-white">{testimonials[currentTestimonial].name}</h4>
                  <p className="text-gray-400">{testimonials[currentTestimonial].role}</p>
                  <div className="flex items-center mt-2">
                    {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                    ))}
                  </div>
                </div>
                <div className="ml-auto text-right">
                  <div className="bg-gradient-to-r from-green-500 to-blue-500 text-white px-3 py-1 rounded-full text-sm font-bold">
                    {testimonials[currentTestimonial].stats}
                  </div>
                </div>
              </div>
              
              <blockquote className="text-xl text-gray-300 italic leading-relaxed mb-6">
                "{testimonials[currentTestimonial].content}"
              </blockquote>
            </div>

            {/* Indicadores */}
            <div className="flex justify-center mt-8 space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentTestimonial(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentTestimonial 
                      ? 'bg-blue-500 w-8' 
                      : 'bg-gray-600 hover:bg-gray-500'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section final poderosa */}
      <section className="py-20 relative">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-purple-600/10" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl p-12 border border-blue-500/30">
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                Pronto para aumentar suas vendas
              </span>
              <br />
              <span className="bg-gradient-to-r from-green-400 to-blue-400 bg-clip-text text-transparent">
                em 60% nos próximos 30 dias?
              </span>
            </h2>
            
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              Junte-se a <strong className="text-white">1000+ escolas</strong> que já transformaram suas cantinas.<br />
              <span className="text-blue-400">Implementação em 24h • Sem taxa de setup • 30 dias grátis</span>
            </p>

            {/* Urgência */}
            <div className="bg-gradient-to-r from-red-500/10 to-orange-500/10 border border-red-500/30 rounded-xl p-4 mb-8">
              <div className="flex items-center justify-center text-orange-400 mb-2">
                <Clock className="w-5 h-5 mr-2" />
                <span className="font-semibold">Oferta por tempo limitado!</span>
              </div>
              <p className="text-gray-300">
                🔥 Apenas <strong className="text-white">47 vagas</strong> restantes para implementação em Janeiro
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6 mb-8">
              <Link
                to="/register"
                className="group bg-gradient-to-r from-green-600 to-blue-600 text-white px-10 py-5 rounded-full text-xl font-bold hover:shadow-2xl hover:shadow-green-500/25 transition-all duration-300 transform hover:scale-105 flex items-center space-x-3"
              >
                <Rocket className="w-6 h-6" />
                <span>Quero Começar Agora</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
              
              <a
                href="tel:+5511999999999"
                className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors"
              >
                <div className="w-12 h-12 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm hover:bg-white/20 transition-colors">
                  <Phone className="w-5 h-5" />
                </div>
                <div className="text-left">
                  <div className="text-lg font-semibold">Falar com Especialista</div>
                  <div className="text-sm text-gray-400">(42) 99992-1514</div>
                </div>
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center space-x-8 text-sm text-gray-400">
              <div className="flex items-center mb-2">
                <Shield className="w-4 h-4 text-green-400 mr-2" />
                <span>Dados 100% seguros</span>
              </div>
              <div className="flex items-center mb-2">
                <UserCheck className="w-4 h-4 text-green-400 mr-2" />
                <span>Suporte dedicado</span>
              </div>
              <div className="flex items-center mb-2">
                <Award className="w-4 h-4 text-green-400 mr-2" />
                <span>Garantia de resultado</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer moderno */}
      <footer id="contato" className="bg-gradient-to-br from-gray-900 to-black border-t border-gray-800 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Logo e descrição */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center space-x-3 mb-6">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl flex items-center justify-center">
                  <Utensils className="w-7 h-7 text-white" />
                </div>
                <span className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                  CantinaTech
                </span>
              </div>
              <p className="text-gray-400 leading-relaxed mb-6 max-w-md">
                A solução mais avançada para modernizar cantinas escolares. 
                Aumente suas vendas, reduza filas e dê controle total aos pais.
              </p>
              <div className="flex space-x-4">
                {[
                  { icon: Facebook, href: "#" },
                  { icon: Twitter, href: "#" },
                  { icon: Instagram, href: "#" },
                  { icon: Linkedin, href: "#" }
                ].map((social, index) => {
                  const Icon = social.icon;
                  return (
                    <a
                      key={index}
                      href={social.href}
                      className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center text-gray-400 hover:text-white hover:bg-blue-600 transition-all duration-300"
                    >
                      <Icon className="w-5 h-5" />
                    </a>
                  );
                })}
              </div>
            </div>
            
            {/* Links */}
            <div>
              <h3 className="font-semibold text-white mb-6">Produto</h3>
              <ul className="space-y-3 text-gray-400">
                <li><a href="#recursos" className="hover:text-white transition-colors">Funcionalidades</a></li>
                <li><a href="#preços" className="hover:text-white transition-colors">Preços</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Demonstração</a></li>
                <li><a href="#" className="hover:text-white transition-colors">API</a></li>
                <li><a href="#" className="hover:text-white transition-colors">Integrações</a></li>
              </ul>
            </div>
            
            {/* Contato */}
            <div>
              <h3 className="font-semibold text-white mb-6">Contato</h3>
              <div className="space-y-4 text-gray-400">
                <div className="flex items-center">
                  <Mail className="w-5 h-5 mr-3 text-blue-400" />
                  <a href="mailto:contato@cantinatech.com.br" className="hover:text-white transition-colors">
                    contato@cantinatech.com.br
                  </a>
                </div>
                <div className="flex items-center">
                  <Phone className="w-5 h-5 mr-3 text-blue-400" />
                  <a href="tel:+5511999999999" className="hover:text-white transition-colors">
                    (42) 99992-1514
                  </a>
                </div>
                <div className="flex items-center">
                  <MapPin className="w-5 h-5 mr-3 text-blue-400" />
                  <span>Ponta Grossa, Pr</span>
                </div>
                <div className="flex items-center">
                  <HeadphonesIcon className="w-5 h-5 mr-3 text-blue-400" />
                  <span>Suporte 24/7</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2025 CantinaTech. Todos os direitos reservados. 
            </p>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors">Política de Privacidade</a>
              <a href="#" className="hover:text-white transition-colors">Termos de Uso</a>
              <a href="#" className="hover:text-white transition-colors">LGPD</a>
            </div>
          </div>
        </div>
      </footer>

      {/* WhatsApp Float Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/5511999999999?text=Olá! Quero saber mais sobre o CantinaTech"
          target="_blank"
          rel="noopener noreferrer"
          className="group bg-green-500 hover:bg-green-600 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 animate-pulse"
        >
          <Phone className="w-6 h-6 group-hover:scale-110 transition-transform" />
        </a>
      </div>
    </div>
  );
};

export default LandingPage;